import { COUNTY_LABELS } from '../../shared/api';
import { KeyValue } from '../../components/ui';
import { fmtDate, fmtDateTime, money, ROLE_LABELS, WORK_TYPE_LABELS } from '../../lib/format';
import type { TabProps } from './types';

export default function OverviewTab({ job }: TabProps) {
  return (
    <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
      <div>
        <h3 className="mb-2 text-sm font-semibold text-ink">Job</h3>
        <KeyValue
          rows={[
            ['Our role', ROLE_LABELS[job.contractorRole]],
            ['County', COUNTY_LABELS[job.county]],
            ['Contracted with', job.contractedWithName],
            ['Their address', job.contractedWithAddress],
            ['Contract amount', money(job.contractAmount)],
            ['Furnishing', WORK_TYPE_LABELS[job.workType] ?? job.workType],
            ['Specially fabricated', job.speciallyFabricated ? 'Yes' : 'No'],
            ['Invoiced', money(job.balance.invoiced)],
            ['Paid', money(job.balance.paid)],
            ['Outstanding', money(job.balance.balance)],
            ['Unpaid suppliers', String(job.unpaidSuppliers)],
            ['Financing eligible', job.financingEligible ? 'Yes' : 'No'],
          ]}
        />
      </div>

      <div className="space-y-8">
        <div>
          <h3 className="mb-2 text-sm font-semibold text-ink">Key dates</h3>
          <KeyValue
            rows={[
              ['Start', fmtDate(job.startDate)],
              ['First labor', fmtDate(job.firstLaborDate)],
              ['First delivery', fmtDate(job.firstDeliveryDate)],
              ['Last work', fmtDate(job.lastWorkDate)],
              ['Scope final', job.finalComplete ? 'Declared final' : 'Open'],
              ['NTO deadline', fmtDate(job.nooDeadline)],
              ['NTO sent', fmtDateTime(job.nooSentAt)],
              ['NTO delivered (all)', fmtDateTime(job.nooDeliveredAllAt)],
              ['Lien deadline', fmtDate(job.lienDeadline)],
              ['Lien filed', fmtDateTime(job.lienFiledAt)],
              ['Enforcement deadline', fmtDate(job.lienEnforcementDeadline)],
            ]}
          />
        </div>

        <div>
          <h3 className="mb-2 text-sm font-semibold text-ink">Property record</h3>
          <KeyValue
            rows={[
              ['Legal owner', job.legalOwner],
              ['Owner mailing address', job.legalOwnerAddress],
              ['Parcel ID', job.parcelId],
              ['Legal description', job.legalDescription ? <span className="text-xs leading-relaxed">{job.legalDescription}</span> : null],
              ['Deed reference', job.deedReference],
              ['Mortgage holder', job.mortgageHolder ?? 'None of record'],
              ['Mortgage holder address', job.mortgageHolderAddress],
            ]}
          />
        </div>
      </div>
    </div>
  );
}
